import { JiraErrorDetail } from './JiraErrorDetail';

export class JiraError {
  constructor(private readonly errors: JiraErrorDetail[]) {}

  getErrors() {
    return this.errors;
  }
}
